import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useParentsAuth } from '../../contexts/ParentsAuthContext';
import LoadingSpinner from '../ui/LoadingSpinner';

const ParentsProtectedRoute = ({ children }) => {
  const { authenticated, loading } = useParentsAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  if (!authenticated) {
    // Redirecionar para login dos pais, salvando a página atual
    return <Navigate to="/parents-login" state={{ from: location }} replace />;
  }

  return children;
};

export default ParentsProtectedRoute;